module.exports = __webpack_public_path__ + "img/spinner.edb43f28.gif";